var map = {
	"./bookmark_deascuola.svg": "4871",
	"./bookmark_formazione.svg": "2933",
	"./bookmark_za.svg": "5824",
	"./bookmark_zm.svg": "eae2",
	"./bookmark_zs.svg": "94bd",
	"./deaflix/arrow_dx.svg": "75e5",
	"./deaflix/arrow_dx_outline.svg": "3904",
	"./deaflix/bookmark.svg": "43cd",
	"./deaflix/bookmark_active.svg": "8156",
	"./deaflix/bookmark_outline.svg": "eec2",
	"./deaflix/bookmark_selected.svg": "6268",
	"./deaflix/close.svg": "368b",
	"./deaflix/close_outline.svg": "0e54",
	"./deaflix/demo.svg": "f4be",
	"./deaflix/demo_box.svg": "88cc",
	"./deaflix/export_outline.svg": "5d95",
	"./deaflix/eye_color.svg": "c14c",
	"./deaflix/eye_colored.svg": "2367",
	"./deaflix/filter.svg": "f597",
	"./deaflix/lock_outline.svg": "06eb",
	"./deaflix/locked.svg": "7223",
	"./deaflix/logo_Deaflix.svg": "c423",
	"./deaflix/materie.svg": "5e0e",
	"./deaflix/minus.svg": "5d27",
	"./deaflix/plus.svg": "e99a",
	"./deaflix/preferiti_unchecked.svg": "2b15",
	"./deaflix/recenti.svg": "56bf",
	"./deaflix/search.svg": "9cd5",
	"./deaflix/search_active.svg": "579c",
	"./deaflix/search_outline.svg": "f2c2",
	"./deaflix/share.svg": "2390",
	"./deaflix/share_outline.svg": "eb81",
	"./deaflix/subjects.svg": "f39c",
	"./deaflix/test.svg": "7777",
	"./deaflix/test_dark.svg": "256e",
	"./deaflix/topics.svg": "640f",
	"./deaflix/topics_all.svg": "fc18",
	"./deprecated.svg": "c726",
	"./evidenza_neg.svg": "1567",
	"./evidenza_pos.svg": "a707",
	"./formazione/dea-formazione-ico-0-6-anni.svg": "c2d6",
	"./formazione/dea-formazione-ico-ambienti-di-apprendimento.svg": "5c12",
	"./formazione/dea-formazione-ico-arte.svg": "3392",
	"./formazione/dea-formazione-ico-asl-orientamento.svg": "9f2e",
	"./formazione/dea-formazione-ico-autonomia-valutazione.svg": "0259",
	"./formazione/dea-formazione-ico-benessere-a-scuola.svg": "20f7",
	"./formazione/dea-formazione-ico-clil.svg": "b666",
	"./formazione/dea-formazione-ico-competenze.svg": "33f9",
	"./formazione/dea-formazione-ico-contrasto-dispersione-scolastica.svg": "08c6",
	"./formazione/dea-formazione-ico-ddi.svg": "8553",
	"./formazione/dea-formazione-ico-didattica-digitale.svg": "2034",
	"./formazione/dea-formazione-ico-didattica-inclusiva.svg": "2e17",
	"./formazione/dea-formazione-ico-ed-civica.svg": "bc5f",
	"./formazione/dea-formazione-ico-fisica.svg": "b2f4",
	"./formazione/dea-formazione-ico-francese.svg": "118e",
	"./formazione/dea-formazione-ico-inglese.svg": "5ff1",
	"./formazione/dea-formazione-ico-innovazione-scolastica.svg": "56d7",
	"./formazione/dea-formazione-ico-italiano.svg": "a028",
	"./formazione/dea-formazione-ico-la-scuola-e-2023.svg": "9cbf",
	"./formazione/dea-formazione-ico-la-scuola-e.svg": "48d2",
	"./formazione/dea-formazione-ico-letteratura.svg": "04f4",
	"./formazione/dea-formazione-ico-matematica.svg": "09bd",
	"./formazione/dea-formazione-ico-mediazione-didattica.svg": "25ce",
	"./formazione/dea-formazione-ico-musica.svg": "d802",
	"./formazione/dea-formazione-ico-parita-di-genere.svg": "8889",
	"./formazione/dea-formazione-ico-pnnr.svg": "629b",
	"./formazione/dea-formazione-ico-religione.svg": "520e",
	"./formazione/dea-formazione-ico-scienze-motorie.svg": "44b1",
	"./formazione/dea-formazione-ico-scienze-umane.svg": "33e4",
	"./formazione/dea-formazione-ico-scienze.svg": "967d",
	"./formazione/dea-formazione-ico-spagnolo.svg": "c7df",
	"./formazione/dea-formazione-ico-stem.svg": "ebea",
	"./formazione/dea-formazione-ico-storia-geografia.svg": "77e3",
	"./formazione/dea-formazione-ico-tecnologia.svg": "ca61",
	"./formazione/downloadable_material.svg": "f008",
	"./formazione/educational_activities.svg": "21a2",
	"./formazione/forum.svg": "fe4b",
	"./formazione/tutorial.svg": "a904",
	"./formazione/video_lessons.svg": "4dc5",
	"./formazione/webinar.svg": "fdc5",
	"./griglia.svg": "1dbf",
	"./hubscuola_core/altra_persona.svg": "1be3",
	"./hubscuola_core/android.svg": "7411",
	"./hubscuola_core/app_di_lettura.svg": "5b42",
	"./hubscuola_core/aree_docenti.svg": "9dac",
	"./hubscuola_core/assegna.svg": "d02e",
	"./hubscuola_core/assistenza.svg": "85f6",
	"./hubscuola_core/attenzione.svg": "397c",
	"./hubscuola_core/attiva_libro.svg": "9ecf",
	"./hubscuola_core/bloccato.svg": "fa05",
	"./hubscuola_core/broken_link.svg": "5cd6",
	"./hubscuola_core/calendario.svg": "ffc5",
	"./hubscuola_core/check.svg": "deed",
	"./hubscuola_core/checkbox-minus.svg": "ab72",
	"./hubscuola_core/checkbox-tick.svg": "656e",
	"./hubscuola_core/chiave_inglese.svg": "b01e",
	"./hubscuola_core/chiudi.svg": "530a",
	"./hubscuola_core/clock.svg": "fcd3",
	"./hubscuola_core/comprimi.svg": "98e5",
	"./hubscuola_core/condivisione.svg": "48c9",
	"./hubscuola_core/copia.svg": "8369",
	"./hubscuola_core/dashboard.svg": "9188",
	"./hubscuola_core/desktop.svg": "e12d",
	"./hubscuola_core/disegna.svg": "8d25",
	"./hubscuola_core/dizionario.svg": "4497",
	"./hubscuola_core/docenti.svg": "cb40",
	"./hubscuola_core/doppia.svg": "9e6e",
	"./hubscuola_core/dots.svg": "5708",
	"./hubscuola_core/download.svg": "82ba",
	"./hubscuola_core/elimina.svg": "bd01",
	"./hubscuola_core/esigenze.svg": "0e40",
	"./hubscuola_core/espandi.svg": "07ff",
	"./hubscuola_core/esporta.svg": "85d4",
	"./hubscuola_core/evidenza.svg": "4523",
	"./hubscuola_core/filtri.svg": "bd83",
	"./hubscuola_core/flag.svg": "4c58",
	"./hubscuola_core/folder.svg": "0edf",
	"./hubscuola_core/freccetta_destra.svg": "a803",
	"./hubscuola_core/freccetta_giù.svg": "f3db",
	"./hubscuola_core/freccetta_giù_small.svg": "d7b4",
	"./hubscuola_core/freccetta_su.svg": "7eff",
	"./hubscuola_core/freccetta_su_small.svg": "df7e",
	"./hubscuola_core/freccia_destra.svg": "5535",
	"./hubscuola_core/freccia_giù.svg": "6272",
	"./hubscuola_core/freccia_su.svg": "b9a7",
	"./hubscuola_core/freccia_su_dx.svg": "7669",
	"./hubscuola_core/genitori.svg": "e5b3",
	"./hubscuola_core/glossario.svg": "632f",
	"./hubscuola_core/gomma.svg": "b6b1",
	"./hubscuola_core/home_bread.svg": "668a",
	"./hubscuola_core/hub_kit.svg": "10ae",
	"./hubscuola_core/imiei_libri.svg": "d74d",
	"./hubscuola_core/impostazioni.svg": "cdc0",
	"./hubscuola_core/indietro.svg": "f091",
	"./hubscuola_core/info.svg": "5b29",
	"./hubscuola_core/invalsi.svg": "fa74",
	"./hubscuola_core/inverti.svg": "6b8d",
	"./hubscuola_core/lavagna.svg": "455a",
	"./hubscuola_core/lesson_plan.svg": "38b2",
	"./hubscuola_core/lesson_plan_card.svg": "467e",
	"./hubscuola_core/link.svg": "6aa6",
	"./hubscuola_core/link_aree.svg": "248d",
	"./hubscuola_core/link_chain.svg": "ced3",
	"./hubscuola_core/link_esterno.svg": "b646",
	"./hubscuola_core/linux.svg": "4458",
	"./hubscuola_core/list.svg": "d33b",
	"./hubscuola_core/loader.svg": "91fe",
	"./hubscuola_core/logout.svg": "ee0d",
	"./hubscuola_core/mac.svg": "9454",
	"./hubscuola_core/menu.svg": "6bba",
	"./hubscuola_core/minus.svg": "8351",
	"./hubscuola_core/modifica.svg": "7a74",
	"./hubscuola_core/muovi.svg": "131d",
	"./hubscuola_core/nascondi.svg": "8426",
	"./hubscuola_core/next.svg": "3cc0",
	"./hubscuola_core/note.svg": "113d",
	"./hubscuola_core/notifiche.svg": "ed4e",
	"./hubscuola_core/offline.svg": "7f33",
	"./hubscuola_core/ok.svg": "0143",
	"./hubscuola_core/pause.svg": "1935",
	"./hubscuola_core/placeholder.svg": "ec21",
	"./hubscuola_core/play.svg": "3087",
	"./hubscuola_core/plus.svg": "c3e7",
	"./hubscuola_core/preferiti.svg": "7d11",
	"./hubscuola_core/preferiti_pieno.svg": "16ca",
	"./hubscuola_core/profilo.svg": "12e7",
	"./hubscuola_core/registro.svg": "ec78",
	"./hubscuola_core/resize.svg": "44bb",
	"./hubscuola_core/ricerca.svg": "d846",
	"./hubscuola_core/ritaglio.svg": "b1c0",
	"./hubscuola_core/salva.svg": "6a3d",
	"./hubscuola_core/scrivi.svg": "d3c8",
	"./hubscuola_core/sfoglia.svg": "940c",
	"./hubscuola_core/shortcut.svg": "d965",
	"./hubscuola_core/singola.svg": "dea5",
	"./hubscuola_core/strumenti.svg": "3ff9",
	"./hubscuola_core/studenti.svg": "c863",
	"./hubscuola_core/tablet.svg": "dbb6",
	"./hubscuola_core/test.svg": "fc0a",
	"./hubscuola_core/testo_liquido.svg": "3bcc",
	"./hubscuola_core/update.svg": "1e1b",
	"./hubscuola_core/upload.svg": "ab3a",
	"./hubscuola_core/visualizza.svg": "15eb",
	"./hubscuola_core/windows.svg": "c79e",
	"./hubscuola_core/zoom.svg": "b986",
	"./hubscuola_file_type/animazione.svg": "fd0e",
	"./hubscuola_file_type/archivio.svg": "4a99",
	"./hubscuola_file_type/audio.svg": "8a41",
	"./hubscuola_file_type/cambia_accordi.svg": "f0c7",
	"./hubscuola_file_type/contenuto_video.svg": "d64f",
	"./hubscuola_file_type/deaflix.svg": "b1db",
	"./hubscuola_file_type/didattica_inclusiva.svg": "97df",
	"./hubscuola_file_type/dizionario.svg": "387a",
	"./hubscuola_file_type/documenti.svg": "9e03",
	"./hubscuola_file_type/esercizio.svg": "64f5",
	"./hubscuola_file_type/flash_card.svg": "91dd",
	"./hubscuola_file_type/foglio_di_calcolo.svg": "eb1e",
	"./hubscuola_file_type/folder.svg": "66d5",
	"./hubscuola_file_type/folder_cms.svg": "dcb4",
	"./hubscuola_file_type/galleria.svg": "d908",
	"./hubscuola_file_type/geogebra.svg": "d388",
	"./hubscuola_file_type/glossario.svg": "284b",
	"./hubscuola_file_type/hub_art.svg": "ca74",
	"./hubscuola_file_type/hub_library.svg": "8e88",
	"./hubscuola_file_type/hub_maps.svg": "bf87",
	"./hubscuola_file_type/hub_music.svg": "222b",
	"./hubscuola_file_type/immagine.svg": "bf878",
	"./hubscuola_file_type/interattivo.svg": "3b3e",
	"./hubscuola_file_type/itinerari.svg": "2507",
	"./hubscuola_file_type/jolly.svg": "9402",
	"./hubscuola_file_type/karaoke.svg": "51af",
	"./hubscuola_file_type/laboratorio.svg": "52ff",
	"./hubscuola_file_type/lezione.svg": "aff2",
	"./hubscuola_file_type/link_esterno.svg": "415b",
	"./hubscuola_file_type/link_interno.svg": "cf38",
	"./hubscuola_file_type/mappa.svg": "a676",
	"./hubscuola_file_type/multimedia.svg": "1d11",
	"./hubscuola_file_type/spartito_animato.svg": "46f8",
	"./hubscuola_file_type/testo_aggiuntivo.svg": "591c",
	"./hubscuola_file_type/verifica.svg": "abf4",
	"./hubscuola_file_type/video_interattivo.svg": "e394",
	"./lista.svg": "a11f",
	"./messages/AP_ico_alert.svg": "44ab",
	"./messages/AP_ico_info.svg": "451c",
	"./messages/AP_ico_question.svg": "3d3d",
	"./notifica-libro.svg": "9411",
	"./prototype.svg": "59a9",
	"./ready.svg": "e951",
	"./review.svg": "08d0",
	"./zonamatematica/ZonaMate_icone_Contenuto.svg": "43f5",
	"./zonamatematica/ZonaMate_icone_Contenuto_bianca.svg": "51dd",
	"./zonamatematica/ZonaMate_icone_GeoGebra.svg": "0cf0",
	"./zonamatematica/ZonaMate_icone_GeoGebra_bianca.svg": "f7af",
	"./zonamatematica/ZonaMate_icone_Metodo.svg": "433c",
	"./zonamatematica/ZonaMate_icone_Metodo_bianca.svg": "4ff2",
	"./zonamatematica/ZonaMate_icone_Obiettivi.svg": "dcbe",
	"./zonamatematica/ZonaMate_icone_Obiettivi_bianca.svg": "8b59",
	"./zonamusica/zMu_ico_ascolto.svg": "3629"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce87";